import { render, staticRenderFns } from "./SuppressedAssetsPage.vue?vue&type=template&id=09fa1b76&scoped=true"
import script from "./SuppressedAssetsPage.vue?vue&type=script&lang=js"
export * from "./SuppressedAssetsPage.vue?vue&type=script&lang=js"
import style0 from "./SuppressedAssetsPage.vue?vue&type=style&index=0&id=09fa1b76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fa1b76",
  null
  
)

export default component.exports